module.exports = __webpack_public_path__ + "static/media/my-account.ad54af3a.svg";